/* ==========================================================================
   ASJ CUSTOM - Mobile navigation drawer enhancement.
   Progressive enhancement of Dawn's native <header-drawer>. Converts the
   sliding submenu panels into an in-place accordion: the label stays a real
   link (follows its Shopify Navigation destination) and a separate chevron
   button expands/collapses the submenu without navigating. Nested Buy menus
   expand in place too. Only one primary section is open at a time.

   Also guards the hero slideshow: while the drawer is open its controls are
   inert (no clicks, no focus, no swipes) and a body flag lets CSS neutralize
   pointer events. All content stays driven by Shopify Navigation. Mobile only
   (the drawer is hidden on desktop). Safe to remove.
   ========================================================================== */
(function () {
  'use strict';

  var CHEVRON = '<svg class="asj-mm__chevron" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M5 8l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var uid = 0;

  function labelOf(summary) {
    var t = '';
    Array.prototype.forEach.call(summary.childNodes, function (n) {
      if (n.nodeType === 3) t += n.textContent;
    });
    return t.trim();
  }

  function submenuList(details) {
    var sub = details.querySelector(':scope > .menu-drawer__submenu');
    return sub ? sub.querySelector('ul.menu-drawer__menu') : null;
  }

  function isTopLevel(li) {
    return li.closest('.asj-mm__panel') === null;
  }

  /* ASJ CUSTOM: the panel animates via CSS grid-template-rows (0fr -> 1fr),
     so we do NOT toggle the `hidden` attribute (display:none cannot transition).
     Visual show/hide is the grid animation; `inert` keeps collapsed submenu
     links out of the tab order for accessibility. */
  function openPanel(toggle, panel) {
    toggle.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('inert');
    panel.classList.add('asj-mm__panel--open');
  }

  function closePanel(toggle, panel) {
    toggle.setAttribute('aria-expanded', 'false');
    panel.querySelectorAll('.asj-mm__toggle[aria-expanded="true"]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var np = document.getElementById(t.getAttribute('aria-controls'));
      if (np) np.classList.remove('asj-mm__panel--open');
    });
    panel.classList.remove('asj-mm__panel--open');
    panel.setAttribute('inert', '');
  }

  function closeSiblings(li) {
    Array.prototype.forEach.call(li.parentNode.children, function (sib) {
      if (sib === li) return;
      var t = sib.querySelector(':scope > .asj-mm__row > .asj-mm__toggle');
      var p = sib.querySelector(':scope > .asj-mm__panel');
      if (t && p && t.getAttribute('aria-expanded') === 'true') closePanel(t, p);
    });
  }

  function enhanceList(ul) {
    Array.prototype.slice.call(ul.children).forEach(function (li) {
      var details = li.querySelector(':scope > details');
      if (!details) return;
      var summary = details.querySelector(':scope > summary');
      if (!summary) return;

      var label = labelOf(summary);
      var url = summary.getAttribute('data-asj-url') || '#';
      var childUl = submenuList(details);
      uid += 1;
      var panelId = 'asj-mm-panel-' + uid;

      var row = document.createElement('div');
      row.className = 'asj-mm__row';

      var link = document.createElement('a');
      link.className = 'asj-mm__link menu-drawer__menu-item link link--text';
      link.href = url;
      link.textContent = label;
      if (summary.classList.contains('menu-drawer__menu-item--active')) {
        link.setAttribute('aria-current', 'page');
      }

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'asj-mm__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', panelId);
      toggle.setAttribute('aria-label', label + ' submenu');
      toggle.innerHTML = CHEVRON;

      row.appendChild(link);
      row.appendChild(toggle);

      var panel = document.createElement('div');
      panel.className = 'asj-mm__panel';
      panel.id = panelId;
      panel.setAttribute('inert', '');
      if (childUl) {
        panel.appendChild(childUl);
        enhanceList(childUl);
      }

      li.replaceChild(row, details);
      li.appendChild(panel);

      toggle.addEventListener('click', function () {
        if (toggle.getAttribute('aria-expanded') === 'true') {
          closePanel(toggle, panel);
        } else {
          if (isTopLevel(li)) closeSiblings(li);
          openPanel(toggle, panel);
        }
      });
    });
  }

  function initDrawer() {
    var root = document.querySelector('header-drawer #menu-drawer .menu-drawer__navigation > ul.menu-drawer__menu');
    if (!root || root.dataset.asjEnhanced) return;
    root.dataset.asjEnhanced = '1';
    enhanceList(root);
  }

  function initHeroGuard() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var sync = function () {
      var open = header.classList.contains('menu-open');
      document.body.classList.toggle('asj-menu-open', open);
      document.querySelectorAll('slideshow-component').forEach(function (s) {
        if (open) s.setAttribute('inert', ''); else s.removeAttribute('inert');
      });
    };
    new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function boot() { initDrawer(); initHeroGuard(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();